import React, { memo, useState, useEffect, useMemo, lazy, Suspense } from 'react';
import KrRow from "../okr_depend_components/krRow.component";
import { okrDetailConstants } from "../../../constants/okr/okrDetails.constants";
import {reactLoader, removeReactLoader} from '../../../utils/common';
import goalServices from '../../../services/goal.services';
import {PageScrollVisible, SetKrContainerHeight} from '../../../utils/function';
const KrModal = lazy(() => import(
  /* webpackChunkName: "kr-modal" */
  './../modals/kr-modal'
));
import { useTranslation } from 'react-i18next';
import { Button } from '@workboard/wobo-ui';

const ShowOnlyKrs  = (props) => {
    const [showModal, setShowModal] = useState(false);
    const [createFromMail, setCreateFromMail] = useState(props.createCascadeEmailEn);
    const [modalProps, setModalProps] = useState({});
    const [disablecascadePopUp, setDisablecascadePopUp] = useState(true);
    const GoalServices = useMemo(() => new goalServices(), []);
    useEffect(() => {
        let metricArr = {};
        let metricData = {};
        if( createFromMail && disablecascadePopUp ){
            metricArr = props.cascadedData[props.createCascadeEmailEn];
            if(metricArr != undefined && metricArr.metric != undefined){
                metricData = metricArr.metric;
                handleOpenModal( metricData[0] );
            }
		}
    }, []);
    useEffect(() => {
        var e = document.querySelector('body');
        if(showModal){
            if(e){
                e.style.overflow = "hidden";
            }
            setTimeout(() => SetKrContainerHeight(), 0);
        }else{
            if(e){
                e.style.overflow = "visible";
            }
        }
    }, [showModal])

    const handleOpenModal = (item, cascadeReq = false) => {
        // console.log('handleOpenModal', item);
        //let _this = this;
        reactLoader();
        let params = {};
        params.metricId = item.id;
        if(cascadeReq){
            params.cascadeReq = true;
        }
        GoalServices.createCascadeDetails(params)
            .then((response) => {
                removeReactLoader();
                if(response.data){
                    // _this.setState({showModal: true, modalProps: response.data.data, disablecascadePopUp: false}, () => {
                    //     // PageScrollVisible();
                    //     var e = document.querySelector('body');
                    //     if(e){
                    //         e.style.overflow = "hidden";
                    //     }
                    //     setTimeout(() => SetKrContainerHeight(), 0);
                    // });


                    setModalProps(response.data.data);
                    setShowModal(true);
                    setDisablecascadePopUp(false);
                }
            })
            .catch(function (error) {
                if (error.response) {
                    removeReactLoader();
                }
              });
	}

	const handleCloseModal = () => {
        // this.setState({ showModal: false, }, () => {
        //     // PageScrollVisible(true);
        //     var e = document.querySelector('body');
        //     if(e){
        //         e.style.overflow = "visible";
        //     }
        // });
        setShowModal(false);
	}

	const goalDetPage = (goalId, metricId = null, hasAccess = true, parentMId = 0) => {
		const params = {};
		params.id = goalId;
		if (metricId != null) {
		  params.metricId = metricId;
		}
		// console.log(parentMId);
		if (parentMId) {
		  return viewCascadeMetric(params.metricId);
		}
		if (hasAccess) {
		  return viewGoalDetailsPage('metric', params);
		}
	}
    const clickProfile = (userId) => {
        var url = wbConfig.baseUrl + '/memberProfile/index?id=' + userId;
        window.open(url, "_blank");
    }
    const renderKrWrapper = (group,userData,showGoalMetrics,showUserName) => {
        return (
            <div>
			{showUserName &&
                <div user_id={group.user_id} className="okr-user-block">
					<div className="okr-user-img"><img src={group.picture} onClick={(e) => clickProfile(group.user_id)} /></div>
					<div className="okr-user-name">{group.name}</div>
					<div className="okr-user-break"></div>
                </div>
            }
            {
                group.teams.map(team =>
					renderKr(team.id,team.name,team.metrics,showGoalMetrics,userData)
				)
            }
            </div>

        )
    }
    const renderKr = (teamId,teamName,metrics,showGoalMetrics,userData) => {
		const style = {};
		const dateStyle = {};
		// if (i == total - 1) {
		style.borderBottomLeftRadius = '4px';
        dateStyle.borderBottomRightRadius = '4px';
		return(
		<div className="okr-group-sub-wrapper" key={`group_team_id_${teamId}`}>
			<div role="heading" aria-level="3" data-testid="okr-group-name-dy" className={`okr-group-name ${teamId == -1 ? "no-associated-team" :""}`}>
				{props.showTeamName ? teamName : ""}
			</div>
			<div className="clear" />
                <ul>
                    {metrics.map((metric, index) =>
                        <li key={index}>
                            <KrRow
                                rIndex = {index}
                                metric={metric}
                                loggedInUser={userData.id}
                                goalStatus={1}
                                goalId={metric.goal_id}
                                teamId={teamId}
                                key={`kr-row-wrarpper-${metric.id}`}
                                showRealOwner = {props.showRealOwner}
                                style={style}
                                dateStyle={dateStyle}
                                showSourceName={props.showSourceName}
                                emojisData={props.emojisData}
                                refSrc={props.type}
                                displayKrConfidence={props.displayKrConfidence}
                                addNewKrAction={props.addNewKrAction}
								deleteKrAction={props.deleteKrAction}
                            />
                            {(typeof metric.nested_krs !== 'undefined' && metric?.nested_krs.length >= 1) && <ul> { metric.nested_krs.map((nestedMetric, index) => (
                                <li key={index}>
                                <KrRow
                                    rIndex = {index}
                                    metric={nestedMetric}
                                    loggedInUser={userData.id}
                                    goalStatus={1}
                                    goalId={metric.goal_id}
                                    teamId={teamId}
                                    key={`kr-row-wrarpper-${nestedMetric.id}`}
                                    showRealOwner = {props.showRealOwner}
                                    style={style}
                                    dateStyle={dateStyle}
                                    showSourceName={props.showSourceName}
                                    emojisData={props.emojisData}
                                    refSrc={props.type}
                                    displayKrConfidence={props.displayKrConfidence}
                                    addNewKrAction={props.addNewKrAction}
                                    deleteKrAction={props.deleteKrAction}
                                    nestedKr={true}
                                    parentMetricId={metric.id}
								    isChildKr={true}
                                /></li>
                                ))}</ul>
                            }
                        </li>
                    )}
                </ul>
		</div>
		)

	}
    // console.log("showOnlyKrCOmponent-render",this.props);
    const {teams,userData,showGoalMetrics,showUserName, type, cascadedData} = props;
    return (
        <div>
            <Suspense fallback={null}>
                <KrModal isOpen={showModal} handleCloseModal={handleCloseModal} data={modalProps} showRealOwner={props.showRealOwner}/>
            </Suspense>
            {
                type == okrDetailConstants.PAGE_TYPE_KR_I_UPDATE &&
                    Object.keys(cascadedData).map((item, index) => (
                        <EachCascadedItem key={item} cascadeItem={cascadedData[item]} goalDetPage={goalDetPage} createKeyResult={handleOpenModal}></EachCascadedItem>
                    ))
            }
            {
                teams.metrics.map(group =>
                    renderKrWrapper(group,userData,showGoalMetrics,showUserName))
            }
        </div>
    );
}

const EachCascadedItem = memo((props) => {
    //console.log('CASCADE', props.cascadeItem);
    const { t } = useTranslation();
    let cascadeItem = props.cascadeItem;
    let metric      = cascadeItem.metric;
    return (
        <div>
        {
            Object.keys(metric).map((item, index) => (
                <div key={"cascademetric-" + index} className="cascadedMainKr" >
                    <div className="cascadedKrTitle" role="heading" aria-level="3"> {t('CASCADED KEY RESULT')} </div>
                    <div className="cascadedWrapper" data-testid='cascadedWrapper'>
                        <div className="cascadedKrDesc" data-testid="cascadedKrDesc">
                            {cascadeItem.firstname +" "+cascadeItem.lastname} {t('has cascaded a key result')}
                            <span className="cascadedKrDescSpanBlack"> {metric[index].name} </span>
                            {t('from their objective')}, {` `}
                            {/* <span className="cascadedKrDescSpanBlack" style={{cursor: (cascadeItem.hasAccess) ? 'pointer' : 'default' }} onClick={() => this.props.goalDetPage(cascadeItem.goalId, metric[index].id, cascadeItem.hasAccess)}>{metric[index].name}</span> from the objective{` `} */}
                            {/* Removed click event - WW-8714 */}
                            <span className="cascadedKrDescSpanBlack">{cascadeItem.goalName}.</span>{` `}
                            <a className="cascadedKrDescSpanBlue" target="_blank" href="https://workboard.zendesk.com/hc/en-us/articles/115009035207-Cascade-key-results-through-the-organization">{t('More information')}</a>
                        </div>
                        <Button className="cascadedKrCreateKrButton" variant="primary" onClick={() => props.createKeyResult({...metric[item], userId: cascadeItem.userId, firstname: cascadeItem.firstname, lastname: cascadeItem.lastname, picture: cascadeItem.picture})} aria-label={`Create cascade for ${t('key result')} ${metric[index].name}`}>{t('Create')}</Button>
                    </div>
                </div>
                ))
        }
        </div>
    )
});
export default ShowOnlyKrs;